import type { icModel } from 'generated-ts-common';
import type { at } from '../generated/Beans';
type Questionnaire = icModel.saf.infrastructure.model.virtualvisit.Questionnaire;
type InstitutionQuestionnaire = at.sense.portlets.saf.virtualvisitpatient.model.InstitutionQuestionnaire;
import { create } from 'zustand';
import { retrieveQuestionaire, sendQuestionnaire } from '../communication/ajax';
import { PortletStoreApi } from '../App';
import { ViewStateStoreApi } from './viewState.store';
import { WaitingRoomStoreApi } from './waitingRoom.store';

export interface QuestionnaireStore {
  loading: boolean;
  currentQuestionIdx: number;
  institutionQuestionnaire?: InstitutionQuestionnaire;
  questionnaireIsLoaded: boolean;
  loadQuestionnaire: () => void;
  sendQuestionnaire: (question: Questionnaire) => void;
  setCurrentQuestionIdx: (idx: number) => void;
}

export const [useQuestionnaireStore] = create<QuestionnaireStore>(set => ({
  loading: false,
  currentQuestionIdx: 0,
  questionnaireIsLoaded: false,
  loadQuestionnaire: async () => {
    console.log('loadQuestionaire');
    try {
      set(state => (state.loading = true));
      set(state => (state.questionnaireIsLoaded = false));
      const vsd = ViewStateStoreApi.getState().viewStateData;
      if (vsd) {
        const resp = await retrieveQuestionaire({
          url: PortletStoreApi.getState().url,
          institutionId: vsd.selectedInstitution.id
        });
        set(state => (state.institutionQuestionnaire = resp.data));
        set(state => (state.questionnaireIsLoaded = true));
      }
    } finally {
      set(state => (state.loading = false));
    }
  },
  sendQuestionnaire: async (question: Questionnaire) => {
    console.log('sendQuestionaire', question);
    const vsd = ViewStateStoreApi.getState().viewStateData;
    const vInfo = WaitingRoomStoreApi.getState().visitInfo;
    if (vsd && vInfo) {
      const resp = await sendQuestionnaire({
        url: PortletStoreApi.getState().url,
        institutionId: vsd.selectedInstitution.id,
        visitId: vInfo.visitId,
        questionnaire: question
      });
      console.log('questionaire sent', resp);
    }
  },
  setCurrentQuestionIdx: (idx: number) => {
    set(state => (state.currentQuestionIdx = idx));
  }
}));
